import './NoticeCard.css';

const BUERO_COLORS = {
  'PA+': { bg: '#e8f0ff', color: '#1a3a7a' },
  'L&L': { bg: '#fff0e8', color: '#7a3a1a' },
  'PWK': { bg: '#f0ffe8', color: '#1a7a3a' },
  'PA+/L&L': { bg: '#f0e8ff', color: '#4a1a7a' },
  'PA+/PWK': { bg: '#e8fff0', color: '#1a7a4a' },
};

const PROCEDURE_LABELS = {
  'open': 'Offenes Verfahren',
  'restricted': 'Nicht offenes Verfahren',
  'neg-w-call': 'Verhandlungsverfahren',
  'neg-wo-call': 'Verhandlungsverfahren (ohne)',
  'comp-dial': 'Wettbewerblicher Dialog',
  'oth-mult': 'Sonstiges',
};

function InfoRow({ label, value }) {
  if (!value) return null;
  return (
    <div className="info-row">
      <span className="info-label">{label}</span>
      <span className="info-value">{value}</span>
    </div>
  );
}

function Section({ title, icon, children }) {
  return (
    <div className="card-section">
      <div className="section-title">{icon && <span>{icon}</span>} {title}</div>
      {children}
    </div>
  );
}

export default function NoticeCard({ notice, selected, expanded, onSelect, onExpand, onExport }) {
  const bueroStyle = BUERO_COLORS[notice.buero] || { bg: '#f0f0f0', color: '#555' };
  const procedureLabel = PROCEDURE_LABELS[notice.procedure] || notice.procedure || '–';

  // Titel kürzen für Listenansicht
  const shortTitle = notice.title?.replace(/^Deutschland\s*[–-]\s*/i, '') || '–';

  return (
    <div className={`notice-card ${selected ? 'selected' : ''} ${expanded ? 'expanded' : ''}`}>

      {/* ── KOPFZEILE (immer sichtbar) ── */}
      <div className="card-header" onClick={onExpand}>
        <div className="card-checkbox-wrap" onClick={e => { e.stopPropagation(); onSelect(); }}>
          <input type="checkbox" checked={selected} readOnly className="card-checkbox" />
        </div>

        <div className="card-main">
          <div className="card-title">{shortTitle}</div>
          <div className="card-meta">
            <span className="card-authority">{notice.authority || '–'}</span>
            {notice.published && <span className="card-date">· {notice.published}</span>}
            {notice.deadline && <span className="card-deadline card-deadline-badge">Frist: {notice.deadline}</span>}
          </div>
        </div>

        <div className="card-badges">
          <span className={`fit-badge fit-${notice.fit || 'Low'}`}>
            {notice.fit === 'High' ? '●' : notice.fit === 'Medium' ? '◐' : '○'} {notice.fit || 'Low'}
          </span>
          {notice.buero && (
            <span className="buero-badge" style={{ background: bueroStyle.bg, color: bueroStyle.color }}>
              {notice.buero}
            </span>
          )}
        </div>

        <div className="card-expand-icon">{expanded ? '▲' : '▼'}</div>
      </div>

      {/* ── AUFGEKLAPPTER INHALT ── */}
      {expanded && (
        <div className="card-body">

          {/* 1. Basisinfos */}
          <Section title="Basisinformationen" icon="📋">
            <div className="info-grid">
              <InfoRow label="Auftraggeber" value={notice.authority} />
              <InfoRow label="Verfahrensart" value={procedureLabel} />
              <InfoRow label="Veröffentlicht" value={notice.published} />
              <InfoRow label="Abgabefrist" value={notice.deadline || 'Nicht angegeben'} />
              <InfoRow label="Geschätzter Wert" value={notice.value ? `${Number(notice.value).toLocaleString('de-DE')} €` : 'Nicht angegeben'} />
              <InfoRow label="TED-Nummer" value={notice.id} />
            </div>
          </Section>

          {/* 2. Beschreibung */}
          {notice.desc && (
            <Section title="Leistungsbeschreibung" icon="📄">
              <div className="text-block">{notice.desc}</div>
            </Section>
          )}

          {/* 3. Eignungskriterien */}
          {notice.eignung && (
            <Section title="Eignungskriterien" icon="✅">
              <div className="text-block text-block-criteria">{notice.eignung}</div>
            </Section>
          )}

          {/* 4. KI-Analyse */}
          {notice.aiDone ? (
            <Section title="KI-Analyse" icon="🤖">
              <div className="info-grid">
                <InfoRow label="Eignung" value={notice.fit} />
                <InfoRow label="Empfohlenes Büro" value={notice.buero} />
              </div>
              {notice.aiBegruendung && (
                <div className="ai-block">
                  <div className="ai-block-label">Begründung</div>
                  <div className="text-block">{notice.aiBegruendung}</div>
                </div>
              )}
              {notice.aiEignung && (
                <div className="ai-block">
                  <div className="ai-block-label">Eignungszusammenfassung</div>
                  <div className="text-block">{notice.aiEignung}</div>
                </div>
              )}
              {notice.aiReferenzen?.length > 0 && (
                <div className="ai-block">
                  <div className="ai-block-label">Passende Referenzen</div>
                  <div className="ref-list">
                    {notice.aiReferenzen.map((r, i) => (
                      <span key={i} className="ref-tag">{r}</span>
                    ))}
                  </div>
                </div>
              )}
            </Section>
          ) : (
            <Section title="KI-Analyse" icon="🤖">
              <div className="ai-pending">KI-Analyse noch nicht verfügbar – Jarvis API-Key ausstehend</div>
            </Section>
          )}

          {/* 5. Aktionen */}
          <div className="card-actions">
            <a href={notice.url} target="_blank" rel="noreferrer" className="btn btn-primary">
              Auf TED öffnen ↗
            </a>
            {onExport && (
              <button className="btn btn-secondary" onClick={() => onExport(notice)}>
                Nach OpenProject exportieren
              </button>
            )}
          </div>

        </div>
      )}
    </div>
  );
}
